import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
const getSizeClasses = sizes => {
  if (['number', 'string'].includes(typeof sizes)) {
    return [`text-size-${parseInt(sizes, 10)}`];
  }
  try {
    return Object.keys(sizes).map(breakpoint => `text-size${breakpoint === 'xs' ? '' : `-${breakpoint}`}-${sizes[breakpoint]}`);
  } catch (e) {
    return null;
  }
};

/**
 *  The Text component takes children and wraps them in a container which utilizes the responsive text classNames
 *
 */
function Text(_ref) {
  let {
    componentClass: Component,
    children,
    ...rest
  } = _ref;
  let props = {};

  // only set up component props if we'll have a wrapping container
  if (Component || Object.keys(rest).length) {
    const {
      size,
      color,
      weight,
      transformCase,
      verticalAlign,
      decoration,
      antialiased,
      className,
      ...other
    } = rest;
    props.className = clsx({
      [`text-${color}`]: color && color !== 'default',
      [`text-${weight}`]: weight,
      [`text-${transformCase}`]: transformCase,
      [`text-valign-${verticalAlign}`]: verticalAlign,
      [`text-${decoration}`]: decoration,
      'text-antialiased': antialiased
    }, getSizeClasses(size), className);
    props = {
      ...other,
      ...props
    };

    // default wrapper to span if nothing specified
    Component = Component || 'span';
  } else {
    Component = React.Fragment;
  }
  if (children) {
    return /*#__PURE__*/React.createElement(Component, props, children);
  }
  return null;
}
export default Text;